import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddNewAlertComponent } from './add-new-alert/add-new-alert.component';
import { AlertPopupComponent } from './alert-popup/alert-popup.component';
import { EditAlertComponent } from './edit-alert/edit-alert.component';
import { ViewAlertsComponent } from './view-alerts/view-alerts.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ElementModule } from 'src/app/elements/element.module';
import { NgDatepickerModule } from 'ng2-datepicker';
import { NotificationComponent } from './notification/notification.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
  declarations: [AddNewAlertComponent, AlertPopupComponent, EditAlertComponent,ViewAlertsComponent, NotificationComponent],
  exports: [AddNewAlertComponent, AlertPopupComponent, EditAlertComponent,ViewAlertsComponent,NotificationComponent],
  imports: [
    CommonModule, NgScrollbarModule, NgxUiLoaderModule, NgDatepickerModule,MyDateRangePickerModule,
    ElementModule,  FormsModule, ReactiveFormsModule,NgMultiSelectDropDownModule.forRoot()
  ]
})
export class AlertModule { }
